import './App.css';
import React, { useState, useEffect } from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route } from "react-router-dom";
import NavBar from './components/navBar/navBar';
import Footer from './components/footer/footer';
import About from './components/about/about';
import RootComponent from './components/Root.jsx';
import './components/styles/stylesheet.css'

function App() {
  const [siteInfo, setSiteInfo] = useState(null);
  const [error, setError] = useState(null);

  // Fetch and load site info from server
  useEffect(() => {
    fetch("/sapi/crm_get_site")
      .then(data => data.json())
      .then(json => setSiteInfo({...json, ...json.styles}))
      .catch(err => setError("Unable to connect to server, please check your connection."))
  }, [])

  // Initial render won't have data (null)
  if (!siteInfo) {
    return (<></>) // todo: Handle invalid sites (piracy or setup issues)
  }

  // Set the title in the browser window
  document.title = siteInfo.title + " Credit Repair Wizard"

  return (
    <Router>
      <NavBar siteInfo={siteInfo} error={error} />
      <Routes>
        <Route path="/" element={<RootComponent siteInfo={siteInfo} setError={setError} />} />
        <Route path="/about" element={<About />} />
      </Routes>
      <Footer siteInfo={siteInfo}  />
    </Router>
  );
}

export default App;
